import ApplicationController from '@aha-app/mvc';
import type Canvas from '../objects/Canvas';

export interface HoveredLink {
  rect: { left: number; top: number; width: number; height: number };
  href: string;
}

interface HoverControllerState {
  hoveredLink?: HoveredLink;
  hoveredLinkTooltipPosition?: 'top';
  isMoving?: boolean;
}

const OFF_TIMEOUT = 200;
const ON_TIMEOUT = 200;

class HoverController extends ApplicationController<HoverControllerState> {
  offTimer?: ReturnType<typeof setTimeout>;
  onTimer?: ReturnType<typeof setTimeout>;
  movingTimer?: ReturnType<typeof setTimeout>;

  get hoveredLink() {
    if (this.state.isMoving) {
      return undefined;
    }
    return this.state.hoveredLink;
  }

  actionSetCanvas(canvas: Canvas) {
    canvas.on('pan', () => this.move());
    canvas.on('zoom', () => this.move());
  }

  actionLinkHovered(hoveredLink: HoveredLink | undefined, position?: 'top') {
    if (hoveredLink) {
      this.show(hoveredLink, position);
    } else {
      this.hide();
    }
  }

  actionLinkClicked() {
    this.hide();
  }

  actionPopupHovered(hovered: boolean) {
    if (hovered) {
      this.show();
    } else {
      this.hide();
    }
  }

  private show(hoveredLink?: HoveredLink, tooltipPosition?: 'top') {
    if (this.offTimer) {
      clearTimeout(this.offTimer);
      this.offTimer = undefined;
    }

    if (this.onTimer) {
      clearTimeout(this.onTimer);
      this.onTimer = undefined;
    }

    if (hoveredLink) {
      // slight delay before updating, so it's not too jumpy
      this.onTimer = setTimeout(() => {
        this.state.hoveredLink = hoveredLink;
        this.state.hoveredLinkTooltipPosition = tooltipPosition;
      }, ON_TIMEOUT);
    }
  }

  private hide() {
    if (this.onTimer) {
      clearTimeout(this.onTimer);
      this.onTimer = undefined;
    }

    if (this.offTimer) {
      return;
    }

    this.offTimer = setTimeout(() => {
      this.state.hoveredLink = undefined;
    }, OFF_TIMEOUT);
  }

  private move() {
    this.state.isMoving = true;
    if (this.movingTimer) {
      clearTimeout(this.movingTimer);
      this.movingTimer = undefined;
    }
    this.movingTimer = setTimeout(() => {
      this.state.isMoving = false;
    }, OFF_TIMEOUT);
  }
}

export default HoverController;
